import ApiHelper from '../utility/ApiHelper';
import APIURLConstants from '../config/config';
import Helper from '../../src/utility/helper';
export const ScheduleDataService = {
    getActivityList,
    getActivityParticipants,
    saveActivityParticipants,
    deleteActivityParticipants,
    deleteUserActivities,
    assignActivityToParticipants,
    importActivity,
    downloadImportTemplate,
    removeActivityByTadId,
    getUserActivityCount,
    publishActivity,
    getUserActivityPublished,
    importMassActivity
};

function getUserActivityPublished(eventId, userId, userType) {
    return ApiHelper.get(
        APIURLConstants.GET_USER_ACTIVITY_PUBLISHED(eventId, userId, userType)
    )
        .then((res) => {
            return res ? res.data : null;
        })
        .catch((err) => {
            console.log(err);
        });
}
function getUserActivityCount(eventId, userId) {
    return ApiHelper.get(
        APIURLConstants.GET_USER_ACTIVITY_COUNT(eventId, userId)
    )
        .then((res) => {
            return res ? res.data : null;
        })
        .catch((err) => {
            console.log(err);
        });
}
function getActivityList(eventId, userId, isUserActTab) {
    const gAgentInfo=Helper.getStorage('agentUser');
    const agentConnection = Helper.getStorage('agentConnections');
    const userInfo = Helper.getStorage('userInfo');
    // console.log("Helper.isAdminUser(userInfo)",Helper.isAdminUser(userInfo));
    const userID = agentConnection && gAgentInfo ? (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) ? 0 : agentConnection && gAgentInfo ? gAgentInfo.userID : userId : agentConnection && gAgentInfo ? gAgentInfo.userID : userId ; 
    return ApiHelper.get(APIURLConstants.GET_ACTIVITY_LIST(eventId, isUserActTab ? userId : userID))
        .then((activity) => {
            return activity;
        })
        .catch((err) => {
            console.log(err);
        });
}

function getActivityParticipants(id) {
    return ApiHelper.get(APIURLConstants.GET_ACTIVITY_PARTICIPANTS(id))
        .then((participants) => {
            return participants.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function saveActivityParticipants(obj) {
    return ApiHelper.post(APIURLConstants.POST_ACTIVITY_PARTICIPANTS, obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}
function publishActivity(obj) {
    return ApiHelper.post(APIURLConstants.POST_PUBLISH_ACTIVITY, obj)
        .then((result) => {
            
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function deleteActivityParticipants(obj) {
    return ApiHelper.post(APIURLConstants.DELETE_ACTIVITY_PARTICIPANTS, obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function deleteUserActivities(obj) {
    return ApiHelper.post(APIURLConstants.DELETE_USER_ACTIVITIES, obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function assignActivityToParticipants(obj) {
    return ApiHelper.post(APIURLConstants.ASSIGN_ACTIVITY_TO_PARTICIPANTS, obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function importActivity(obj, userType) {
    return ApiHelper.post(APIURLConstants.ACTIVITY_EXCEL_IMPORT(userType), obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function importMassActivity(obj, userType) {
    return ApiHelper.post(APIURLConstants.ACTIVITY_MASS_EXCEL_IMPORT(userType), obj)
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}


function downloadImportTemplate() {
    return ApiHelper.get(APIURLConstants.GET_EXCEL_ACTIVITY_TEMPLATE, {
        responseType: 'arraybuffer',
    })
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}

function removeActivityByTadId(obj) {
    return ApiHelper.post(
        APIURLConstants.REMOVE_ACTIVITY_BY_TAGID(obj.eventID),
        obj
    )
        .then((result) => {
            return result.data;
        })
        .catch((err) => {
            console.log(err);
        });
}
